export const KEYS = {
  PAGE_SIZE: 40,
};

export default KEYS;
